import React, { useContext, useEffect } from "react";
import SEO from "../components/SEO";
import HeroSection2022 from "../components/partials/home-2022/HeroSection2022";
import CommunitySlideshow from "../components/partials/home-2022/CommunitySlideshow";
import PrivacySection from "../components/partials/home-2022/PrivacySection";
import AlternatedFeaturesSection from "@src/components/AlternatedFeaturesSection";
import BrandLoveSection from "@src/components/partials/about/BrandLoveSection";
import { graphql, useStaticQuery } from "gatsby";
import CTASection from "@src/components/CTASection";
import { logEvent } from "@src/utils/logClient";
import { useStartExperiment } from "@src/utils/experiment";
import { AppDataContext } from "@src/components/AppDataContext";

const IndexPage: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      directus {
        page_home_2022 {
          features
          privacy_link
          cta_button_url
          cta_background_image_url
        }
        page_careers {
          brand_love_images
          brand_love_tweets
        }
      }
    }
  `);
  const {
    directus: {
      page_home_2022: { features, privacy_link, cta_button_url, cta_background_image_url },
      page_careers: { brand_love_images, brand_love_tweets },
    },
  } = data;

  const HeroSection2022Props = {
    hero_title: "directus.page_home_2022.title",
    hero_subtitle: "directus.page_home_2022.subtitle",
    hero_subtitle_underlined: "directus.page_home_2022.subtitle_underlined",
    get_started_title: "directus.page_home_2022.get_started_title",
    review_count: "directus.page_home_2022.review_count",
  };

  const CommunitySlideshowProps = {
    title: "directus.page_home_2022.carousel_title",
  };

  const AlternatedFeaturesSectionProps = {
    invert_desktop_order: true,
    title: "",
    text: "",
    content: features,
    page: "page_home_2022",
    featureRepeater: "features",
    featureTitle: "title_",
    featureText: "text_",
    textOnTop: true,
    home_variation: true,
  };
  const BrandLoveSectionProps = {
    brand_love_title: "directus.page_home_2022.brand_love_title",
    brand_love_text: "",
    brand_love_images,
    brand_love_tweets,
    brand_love_cta_text: "directus.page_careers.brand_love_cta_text",
    three_liner: false,
    translate: true,
    home_variation: true,
    BGColor: false,
  };
  const PrivacySectionProps = {
    privacy_title: "directus.page_home_2022.privacy_title",
    privacy_subtitle: "directus.page_home_2022.privacy_subtitle",
    privacy_link,
    privacy_link_label: "directus.page_home_2022.privacy_link_label",
  };
  const CTASectionProps = {
    cta_title: "directus.page_home_2022.cta_title",
    cta_button_text: "directus.page_home_2022.cta_button_text",
    cta_background_image_url,
    cta_advice: "",
    button_log_event_name: "web.external_page.cta_signup_click",
    params: {},
    home_variation: true,
  };

  const appCtx = useContext(AppDataContext);
  const getSession = appCtx.data.services.getSession;

  useEffect(() => {
    const logAfterSession = async () => {
      if (getSession) {
        await getSession();
        logEvent({ eventName: "web.external_page.page_view" });
      }
    };
    logAfterSession();
  }, [getSession]);

  // parent and teachers on mobile under the experiment will navigate right away to their app
  return (
    <>
      <SEO />
      <HeroSection2022 {...HeroSection2022Props} />
      <CommunitySlideshow {...CommunitySlideshowProps} />
      <AlternatedFeaturesSection {...AlternatedFeaturesSectionProps} />
      <BrandLoveSection {...BrandLoveSectionProps} />
      <PrivacySection {...PrivacySectionProps} />
      <CTASection {...CTASectionProps} />
    </>
  );
};
export default IndexPage;
